import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PPCGraphData } from '../../types/device';

type ContextState = Data<PPCGraphData>;
const Context = React.createContext<ContextState | null>(null);
function usePPCGraphDetails(): ContextState{
    const contextState = React.useContext(Context);
    if(contextState === null){
        throw new Error('usePPCGraph details must be used within a PPC Graph');
    }
    return contextState;
}

const PPCGraphDataProvider: React.FC<{ deviceId: string; channelNumber: any; startDate: string; endDate: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'PPC-graph',
        id:`${props.deviceId}-${props.channelNumber}-${props.startDate}-${props.endDate}`,
        dataFn: React.useCallback(
            (): Promise<PPCGraphData> => ChartManager.getPPCApiResponse(authHelper,props.deviceId,props.channelNumber,props.startDate,props.endDate),
            [
            authHelper,
            props.deviceId,
            props.channelNumber,
            props.startDate,
            props.endDate
        ]),
    });
   
    const ppcGraphResponseData = dataFromDataset(dataset);  
    return <Context.Provider value={ppcGraphResponseData}>{props.children}</Context.Provider>;
};
const TestPPCGraphDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { TestPPCGraphDataProvider, PPCGraphDataProvider, usePPCGraphDetails };